import { render, staticRenderFns } from "./IntentsListTraining.vue?vue&type=template&id=2bdc5481"
import script from "./IntentsListTraining.vue?vue&type=script&lang=js"
export * from "./IntentsListTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports